<template>
  <v-card flat rounded="lg">
    <v-card-title class="primary--text">Minhas Áreas de interesse</v-card-title>
    <v-card-text>
      <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
      <template v-else>
        <areas-interesse />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import AreasInteresse from "@/components/inscricao/AreasInteresse.vue";
import { mapActions } from "vuex";
export default {
  components: { AreasInteresse },
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions(["getAreasInteresse"]),
  },
  async mounted() {
    this.loading = true;
    await this.getAreasInteresse();
    this.loading = false;
  },
};
</script>

<style>
</style>